<template>
  <b-row>
    <b-col>
      <b-card title="Datos de pago">
        <ValidationObserver ref="observer">
          <b-form @submit.prevent="save">
            <b-row class="pt-4">
              <b-col lg="4">
                <validation-provider
                  name="método de pago"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                <b-form-group id="input-group-company1" label="Método de pago:" label-for="input-company1" :invalid-feedback="validationContext.errors[0]" >
                  <b-form-select id="input-company1" v-model="form.idPaymentMethod" :options="paymentMethods" required
                  :state="getValidationState(validationContext)"></b-form-select>
                </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="4" v-if="!isInPaymentMethod">
                <validation-provider
                  name="banco"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group id="input-group-company2" label="Banco:" label-for="input-company2" :invalid-feedback="validationContext.errors[0]" >
                    <b-form-select id="input-company2" v-model="form.idBank" :options="banks" required
                    :state="getValidationState(validationContext)"></b-form-select>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="4" v-if="!isInPaymentMethod">
                <validation-provider
                  name="tipo de cuenta"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group id="input-group-company3" label="Tipo de cuenta:" label-for="input-company3" :invalid-feedback="validationContext.errors[0]" >
                    <b-form-select id="input-company3" v-model="form.idBankAccountType" :options="bankAccountTypes" required
                    :state="getValidationState(validationContext)"></b-form-select>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="4" v-if="!isInPaymentMethod">
                <validation-provider
                  name="No. cuenta bancaria"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                <b-form-group id="input-group-company4" label="No. cuenta bancaria:" label-for="input-company4" :invalid-feedback="validationContext.errors[0]" >
                  <the-mask class="form-control" :mask="['####-####-####-####-####']" v-model="form.bankAccountNumber" required autocomplete="shut-up-google"
                  :state="getValidationState(validationContext)" placeholder="Ingrese el número de cuenta"/>
                  <!-- <b-form-input id="input-company4" v-model="form.bankAccountNumber" required autocomplete="shut-up-google"
                  :state="getValidationState(validationContext)" placeholder="Ingrese el número de cuenta"></b-form-input> -->
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="4">
                <validation-provider
                  name="frecuencia de pago"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group id="input-group-company5" label="Frecuencia de pago:" label-for="input-company5" :invalid-feedback="validationContext.errors[0]" >
                    <b-form-select id="input-company5" v-model="form.idPaymentPeriod" :options="paymentPeriod" required
                    :state="getValidationState(validationContext)"></b-form-select>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="4">
                <validation-provider
                  name="fecha de inicio de liquidación"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group id="input-group-company6" label="Fecha de inicio de liquidación:" label-for="input-company6" :invalid-feedback="validationContext.errors[0]" >
                    <!-- <label for="example-datepicker">Fecha de inicio de liquidación</label> -->
                    <b-form-datepicker id="input-company6" label="fecha de inicio de liquidación:" v-model="form.payStartDate"  :invalid-feedback="validationContext.errors[0]"
                    placeholder="Fecha de inicio de liquidación" class="mb-2"
                    value-as-date :state="getValidationState(validationContext)"></b-form-datepicker>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pull-right">
                <b-button variant="primary" type="submit" class="mr-2 mb-3 mt-3">Guardar cambios</b-button>
                <!-- <b-button @click="save()" variant="primary" type="submit" class="mr-2 mb-3 mt-3">Guardar cambios</b-button> -->
                <b-button  v-on:click="$emit('set-config', 0)" class="btn btn-light btn-sm" variant="light">
                  Ir atrás
                </b-button>
              </b-col>
              <!-- v-on:click="$emit('set-config', dataConfig)" -->
            </b-row>
          </b-form>
        </ValidationObserver>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import apiClient2 from '@/services/axios/v2.js'
import { mapState } from 'vuex'
import { TheMask } from 'vue-the-mask'
// import { validateDV } from '@/services/utilities'

export default {
  name: 'paymentSettings',
  components: {
    TheMask,
  },
  data() {
    return {
      paymentMethods: [],
      paymentPeriod: [],
      bankAccountTypes: [],
      banks: [],
      invalid: false,
      form: {
        idPaymentMethod: null,
        idPaymentPeriod: null,
        payStartDate: null,
        idBankAccountType: null,
        idBank: null,
        bankAccountNumber: '',
      },
    }
  },
  computed: {
    ...mapState(['user']),
    isInPaymentMethod: {
      get () {
        const list = ['20 ', '23 ', '25 ', '26 ', '92 ', '10 ', '71 ', '1  ', '8  ', '24 ', '34 ', '24',
          '34 ', '48 ', '49 ', '50 ', '51 ', '52 ', '53 ', '60 ', '61 ', '62 ', '63 ', '64 ', '65 ', '66',
          '67 ', '70 ', '74 ', '75 ', '76 ', '77 ', '78 ', '91 ', '93  ', '94 ', '95 ', '96 ', '97 ', '98 ', 'ZZZ']
        return list.includes(this.form.idPaymentMethod)
      },
      set (newValue) {
        return newValue
      },
    },
  },
  created () {
    // TODO Una vez implementado el get de school en la v2 de la api
    // se puede hacer un promise.all como dice esta pagina: https://blog.logrocket.com/using-axios-all-make-concurrent-requests/
    apiClient2.get('/banks').then(data => {
      this.banks = data.data.data.map((x) => {
        return {
          value: x.id,
          text: x.name,
        }
      })
      this.banks.unshift({ value: null, text: 'Seleccione una opción' })
    })
    apiClient2.get('/payment-methods').then(data => {
      this.paymentMethods = data.data.data.map((x) => {
        return {
          value: x.id,
          text: x.name,
        }
      })
      this.paymentMethods.unshift({ value: null, text: 'Seleccione una opción' })
    })
    apiClient2.get('/payment-periods').then(data => {
      this.paymentPeriod = data.data.data.map((x) => {
        return {
          value: x.id,
          text: x.name,
        }
      })
      this.paymentPeriod.unshift({ value: null, text: 'Seleccione una opción' })
    })
    apiClient2.get('/bank-account-types').then(data => {
      this.bankAccountTypes = data.data.data.map((x) => {
        return {
          value: x.id,
          text: x.name,
        }
      })
      this.bankAccountTypes.unshift({ value: null, text: 'Seleccione una opción' })
    })
    apiClient2.get('/company/1').then(data => {
      this.form.idPaymentMethod = data.data.data.idPaymentMethod
      this.form.idPaymentPeriod = data.data.data.idPaymentPeriod
      this.form.payStartDate = data.data.data.payStartDate
      this.form.idBankAccountType = data.data.data.idBankAccountType
      this.form.idBank = data.data.data.idBank
      this.form.bankAccountNumber = data.data.data.bankAccountNumber
    }).catch(error => {
      console.log(error)
      this.$notification.error({
        message: 'Ooops ocurrió un error',
        description: error.response.data.msg,
      })
    })
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    async save() {
      const isValid = await this.$refs.observer.validate()
      console.log(isValid)
      if (isValid) {
        if (this.isInPaymentMethod) {
          this.form.idBankAccountType = null
          this.form.bankAccountNumber = ''
          this.form.idBank = null
        }
        apiClient2.patch('/company/1', this.form).then(response => {
          this.$notification.success({
            message: 'Cambio guardado',
            description: 'La institución ha sido actualizada exitosamente.',
          })
        }).catch(error => {
          console.log(error)
          this.$notification.error({
            message: 'Ooops ocurrió un error',
            description: error.response.data.msg,
          })
        })
      }
    },
  },
  watch: {
  },
}
</script>
